import { HttpParams } from "@angular/common/http";

export const createRequestOptionAllRecords = (req: any): HttpParams => {
  let options: HttpParams = new HttpParams();

  if (req) {
    Object.keys(req).forEach((key) => {
      if (key !== '__skipPageReset') {  
        options = options.set(key, req[key]);
      }
    });

    if (!req.sort) {
      options = options.set("sort", "id,desc");
    }

    const skipReset = req['__skipPageReset'];

    if (!skipReset && (req.page === undefined ||
        req['fullName.contains'] ||
        req['name.contains'] ||
        req['firstName.contains'] ||
        req['studentId.equals'] ||
        req['staffId.equals'] ||
        req['refTable.contains'] ||
        req['id.equals'] ||
        req['refTable.equals'] ||
        req['staffName.contains'] ||
        req['roomId.equals'])) {
      options = options.set("page", "0");
    }

    if (req.size === undefined) {
      options = options.set("size", "500");
    }
  } else {
    options = options.set("sort", "id,desc");
    options = options.set("page", "0");
    options = options.set("size", "500");
  }

  return options;
};


  export const createRequestOptionAllRecordsTransaction = (req: any): HttpParams => {  
    let options: HttpParams = new HttpParams();    
    if (req) {
      Object.keys(req).forEach((key) => {
        options = options.set(key, req[key]);
      });
      // if (!req.sort) {
      //   options = options.set("sort", "id,desc");
      // }
      if (req.page === undefined || req['fullName.contains'] || req['name.contains'] || req['firstName.contains'] || req['studentId.equals'] || req['staffId.equals'] || req['refTable.contains']) {                
        options = options.set("page", "0");
      }
      if (req.size === undefined) {
        options = options.set("size", "500");
      }
    } else {
      // options = options.set("sort", "id,desc");
      options = options.set("page", "0");
      options = options.set("size", "500");
    }
    return options;
  };
